import PlayPage from 'app/components/pages/play';
import {addGaEvent} from 'app/ga_methods';
import {getAllFiltersFlag} from 'app/utils';
import {TableStore} from 'app/store/TableStore';
import {QuickBetStore} from 'app/store/QuickBetStore';
import {QuickBetsFilterStore} from 'app/store/filters/QuickBetsFilterStore';
import EventInterface from 'app/interfaces/EventInterface';
import {DEFAULT_EVENTS} from 'app/store';

const MILLISECONDS_PER_SECOND = 1000;
const SORT_BEFORE = -1;
const SORT_AFTER = 1;

export const useQuickBetsFilteredLineIds = (quickBetStore: QuickBetStore): {
    filteredLineIds: number[];
    currentEvents: string[];
} => {
    const filterStore = quickBetStore.filterStore as QuickBetsFilterStore;
    const allFilters = filterStore.getFilters();

    const filterOptions = {
        currentEvents: filterStore.getCurrentEvents(),
        only24h: filterStore.getOnly24h(),
        onlyUpcomingMatches: filterStore.getOnlyUpcomingMatches(),
        results: false,
        showAllByFilters: filterStore.showAllFilters
    };

    const now = Math.floor(Date.now() / MILLISECONDS_PER_SECOND);
    const filteredLineIds = quickBetStore.linesList
        .filter(model => Boolean(PlayPage.commonFilter(allFilters, model.raw, filterOptions)))
        .sort((a, b) => {
            const aFuture = a.date > now;
            const bFuture = b.date > now;

            if (aFuture && !bFuture) {
                return SORT_BEFORE;
            }
            if (!aFuture && bFuture) {
                return SORT_AFTER;
            }
            return a.date - b.date;
        })
        .map(m => m.id);

    return {currentEvents: filterStore.getCurrentEvents(), filteredLineIds};
};

export const useQuickBetsFilterProps = (quickBetStore: QuickBetStore, tableStore: TableStore): Record<string, unknown> => {
    const filterStore = quickBetStore.filterStore as QuickBetsFilterStore;
    const allFilters = filterStore.getFilters();
    const tableFilters = new Set(quickBetStore.linesList.map(m => m.filter));
    const betFilters = allFilters.filter(f => tableFilters.has(f.id));

    const clearFiltersForQuickBets = (): void => {
        const filters = filterStore.currentFilters().slice().filter(f => f.val === true);
        filterStore.changeFiltersVal(filters);
        filterStore.clearFilters();
        const events: EventInterface[] = [];

        quickBetStore.linesList.forEach(model => {
            const {tourn, filter: filterId, game} = model.raw;

            if (!events.find(e => e.tourn === tourn && e.filter === filterId)) {
                events.push({filter: filterId, game, tourn});
            }
        });
        filterStore.update({
            events,
            showAllFilters: getAllFiltersFlag(filterStore.getFilters())
        });
        tableStore.streamStore.setCurrentEvents(DEFAULT_EVENTS);
        addGaEvent('Filters', 'clear');
    };

    const quickBetsTableStore = Object.create(tableStore, {
        clearFilters: {value: clearFiltersForQuickBets},
        filterStore: {value: filterStore},
        setCurrentEvent: {
            value: (currentEvents: EventInterface[]) => {
                filterStore.setCurrentEvent(currentEvents);
            }
        }
    });

    return {
        currentEvents: filterStore.getCurrentEvents(),
        events: filterStore.getEvents(),
        filters: betFilters,
        only24h: filterStore.getOnly24h(),
        onlyUpcomingMatches: filterStore.getOnlyUpcomingMatches(),
        showAllFilters: filterStore.showAllFilters,
        showMoreFilter: tableStore.showMoreFilter,
        tableCompact: tableStore.tableCompact,
        tableFilters,
        tableStore: quickBetsTableStore
    };
};
